import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiVersionsService } from '../../../../services/versions/api/api-versions.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-version-add-modal',
  templateUrl: './version-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class VersionAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  apiVersion: string = '';
  minAppVersion: string = '';
  gameServerVersion: string = '';
  isActive: boolean = false;

  private callbackSaved?: () => void;

  constructor(private apiVersionsService: ApiVersionsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.apiVersion = '';
    this.minAppVersion = '';
    this.gameServerVersion = '';
    this.isActive = false;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiVersionsService.addVersion(this.apiVersion, this.minAppVersion, this.gameServerVersion, this.isActive).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Version added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding version : ' + error);
      }
    );
  }
}
